import layout from './ReducedHeaderView.html?raw';
import ComponentManager from '@/Management/ComponentManager';
import HeaderView from '@/Views/HeaderView';
import ReducedHeaderViewModel from '@/Components/ReducedHeader/ReducedHeaderViewModel';

export default class ReducedHeaderView extends HeaderView {
    public constructor(protected readonly viewModel: ReducedHeaderViewModel, protected readonly element?: JQuery<HTMLElement>, protected readonly customLayout?: string) {
        super(viewModel, element, customLayout);
    }

    public getView(): JQuery<HTMLElement> {
        if (this.view != null) {
            return this.view;
        }

        this.view = this.applyBindings(this.element, this.viewModel, this.customLayout != null ? this.customLayout : layout);

        return this.view;
    }
}

ComponentManager.setView('ReducedHeader', ReducedHeaderView, 'RADPresentation.HTMLClient.DefaultViewExtensions');